export function drawCoveredImage(
  ctx: CanvasRenderingContext2D,
  img: HTMLImageElement,
  x = 0,
  y = 0,
  w = ctx.canvas.width,
  h = ctx.canvas.height,
  offsetX = 0.5,
  offsetY = 0.5,
): void {
  offsetX = Math.max(0, Math.min(1, offsetX));
  offsetY = Math.max(0, Math.min(1, offsetY));

  const iw = img.width;
  const ih = img.height;
  let r = Math.min(w / iw, h / ih);
  let nw = iw * r;
  let nh = ih * r;
  let ar = 1;

  if (nw < w) ar = w / nw;
  if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;
  nw *= ar;
  nh *= ar;

  const cw = iw / (nw / w);
  const ch = ih / (nh / h);
  const cx = Math.max(0, (iw - cw) * offsetX);
  const cy = Math.max(0, (ih - ch) * offsetY);

  ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);
}
